export default "__VITE_ASSET__DmSW28SA__"